import type { Scorecard } from '@/types/analysis';

export function isOriginalityExcluded(scorecard: Scorecard): boolean {
  if (scorecard.originality_excluded_from_calculation) return true;
  const vs = scorecard.v7_scores ?? scorecard.v6_scores;
  if (vs?.originality_excluded_from_calculation) return true;
  const pct = vs?.originality_pct;
  return pct != null && !Number.isNaN(pct) && pct <= 0;
}

export function originalityMatchedFilm(scorecard: Scorecard): string | null {
  return (
    scorecard.originality_matched_film ??
    scorecard.v7_scores?.originality_matched_film ??
    scorecard.v6_scores?.originality_matched_film ??
    null
  );
}

export function formatOriginalityDisplay(scorecard: Scorecard): string {
  if (isOriginalityExcluded(scorecard)) return 'N/A';
  const vs = scorecard.v7_scores ?? scorecard.v6_scores;
  const pct = vs?.originality_pct;
  if (pct == null || Number.isNaN(pct)) return '—';
  const r = Math.round(pct * 10) / 10;
  return `${r.toFixed(1)}%`;
}

export function originalityExclusionNotice(scorecard: Scorecard): string | null {
  if (scorecard.originality_exclusion_notice) return scorecard.originality_exclusion_notice;
  if (!isOriginalityExcluded(scorecard)) return null;
  const film = originalityMatchedFilm(scorecard) ?? 'an existing produced film';
  return (
    `This screenplay is structurally identical to ${film}, so Originality is not ` +
    'scored as a new work. Commerciality is calculated from Target Market only.'
  );
}

/** Forensic "Narrative volatility" bar — N/A when originality excluded. */
export function originalityVolatilityValue(scorecard: Scorecard): number | null {
  if (isOriginalityExcluded(scorecard)) return null;
  const vs = scorecard.v7_scores ?? scorecard.v6_scores;
  const pct = vs?.originality_pct;
  if (pct == null || Number.isNaN(pct)) return null;
  return Math.round(pct);
}
